// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1zKAZ","validationTips":"StatementDescriptor_validationTips__1dwxF"};